import React from "react";
import { WalletCards, X } from "lucide-react";

const DrawerFormModal = ({ terminal, form, setForm, onClose, onSubmit }) => {
  return (
    <>

    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 montserrat-font-1">
      <div className="bg-white w-full max-w-xl rounded-2xl shadow-2xl p-6 animate-scaleIn">
        {/* HEADER */}
        <div className="flex justify-between items-start mb-6">
          <div>
            <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
              <WalletCards size={21} className="text-blue-600" />
              Add New Drawer
            </h2>

            <p className="text-sm text-gray-500 mt-1">
              Attach drawer to selected terminal.
            </p>
          </div>

          <button
            onClick={onClose}
            className="w-9 h-9 flex items-center justify-center rounded-full border hover:bg-gray-100"
          >
            <X size={18} />
          </button>
        </div>

        {/* TERMINAL INFO */}
        <div className="bg-green-50 border border-green-100 rounded-xl p-4 mb-6">
          <p className="text-xs text-gray-500 mb-1">Selected Terminal</p>

          <div className="grid sm:grid-cols-3 gap-3 text-sm">
            <div>
              <p className="text-gray-500 text-xs">Terminal ID</p>
              <p className="font-semibold text-gray-800">
                #{terminal.pk_terminal_id}
              </p>
            </div>

            <div>
              <p className="text-gray-500 text-xs">Terminal Name</p>
              <p className="font-semibold text-gray-800">
                {terminal.terminal_name || "-"}
              </p>
            </div>

            <div>
              <p className="text-gray-500 text-xs">Terminal Code</p>
              <p className="font-semibold text-gray-800">
                {terminal.terminal_code || "-"}
              </p>
            </div>
          </div>
        </div>

        {/* FORM */}
        <div className="grid sm:grid-cols-2 gap-5">
          <div>
            <label className="text-sm text-gray-600">Drawer Name</label>

            <input
              type="text"
              value={form.drawerName}
              onChange={(e) =>
                setForm({
                  ...form,
                  drawerName: e.target.value,
                })
              }
              className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
              placeholder="Example: Main Cash Drawer"
            />
          </div>

          <div>
            <label className="text-sm text-gray-600">Drawer Code</label>

            <input
              type="text"
              value={form.drawerCode}
              onChange={(e) =>
                setForm({
                  ...form,
                  drawerCode: e.target.value,
                })
              }
              className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
              placeholder="Example: CHAAFO-D1"
            />
          </div>

          <div className="sm:col-span-2">
            <label className="text-sm text-gray-600">Device ID</label>

            <input
              type="text"
              value={form.deviceId}
              onChange={(e) =>
                setForm({
                  ...form,
                  deviceId: e.target.value,
                })
              }
              className="w-full mt-1 border rounded-xl px-3 py-2.5 focus:ring-2 focus:ring-green-400 outline-none"
              placeholder="Example: Admin_1"
            />
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 mt-7">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg border hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={onSubmit}
            className="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white font-medium"
          >
            Save Drawer
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default DrawerFormModal;